import { debounce } from "../utils/performance";
import Slider from "./slider";

export default function(el) {
    // const slider = Slider(el);
    let rowHeights = [];

    const loopSlideCells = (cb) =>
        el.querySelectorAll(".ct__slide").forEach((slide) => {
            const cells = slide.querySelectorAll(".ct__cell");

            if (cells.length === 0) return;

            cells.forEach((cell, index) => cb.call(null, cell, index));
        });

    const getRowHeights = (cell, index) => {
        const cellHeight = cell.offsetHeight;

        if (!rowHeights[index] || cellHeight > rowHeights[index]) rowHeights[index] = cellHeight;
    };

    const setCellHeight = (cell, index) => {
        if (rowHeights[index] && cell.offsetHeight < rowHeights[index])
            cell.style.height = `${rowHeights[index]}px`;
    };

    const setCellsHeights = () => {
        rowHeights = [];
        loopSlideCells(getRowHeights);
        loopSlideCells(setCellHeight);
    };

    const handleWindowResize = debounce(setCellsHeights, 300, false);

    window.addEventListener("resize", handleWindowResize);

    // Workaround
    setTimeout(() => {
        const slider = Slider(el);
        setCellsHeights();
    }, 15);
}
